import * as React from 'react';

import Skeleton from '@/components/elements/Skeleton';
import { NewsType } from '@/pages/News/types';
import { defaultTheme } from '@/utility/theme';

import { List, ListItem, TitleWrapper } from '../style';
import { StyledLink, Thumbnail } from './style';

interface NewsIndexListSkeletonProps {
  type: NewsType;
  count: number;
  isTop?: boolean;
  visiblePublishedAt?: boolean;
}

const NewsIndexListSkeleton: React.FC<NewsIndexListSkeletonProps> = ({
  type,
  count,
  isTop = false,
  visiblePublishedAt = true,
}) => {
  return (
    <List hasBorder={isTop}>
      {[...Array(count)].fill('').map((_, i) => (
        <ListItem key={`skeleton-${i}`}>
          <StyledLink>
            {type !== NewsType.News && (
              <div>
                <Thumbnail>
                  <Skeleton width="100%" height="100%" />
                </Thumbnail>
              </div>
            )}
            <TitleWrapper isNews={type === NewsType.News && !isTop}>
              {visiblePublishedAt && <Skeleton height="18px" width="100px" />}
              <Skeleton
                height="20px"
                width="100%"
                count={i % 3 || 1}
                style={{ marginBottom: defaultTheme.spacing.xs }}
              />
            </TitleWrapper>
          </StyledLink>
        </ListItem>
      ))}
    </List>
  );
};

export default NewsIndexListSkeleton;
